// extracted by mini-css-extract-plugin
export default {"container":"_1Pipm","large":"_3qbYE","search":"_18bE5","categoryLink":"_3gzaC","link":"_2fNpn"};